export enum PackageTrackingStatus {
  CANCELLED = 'CANCELLED',
  IN_REVIEW = 'IN_REVIEW',
  IN_WAITING = 'IN_WAITING',
  IN_PROCESSING = 'IN_PROCESSING',
  ON_DELIVERY = 'ON_DELIVERY',
  IN_DELAY = 'IN_DELAY',
  UNDELIVERABLE = 'UNDELIVERABLE',
  DELIVERED = 'DELIVERED'
}

export enum StatusOfTrackingInfo {
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  TA = 'TA',
  TO = 'TO',
  INUS = 'INUS',
  DELIVERED = 'DELIVERED',
  CLOSED = 'CLOSED'
}

export enum ModifyHiddenList {
  CANCELLED = 'CANCELLED'
}

export enum ReturnReplaceHiddenList {
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  NEW = 'NEW',
  PROCESSING = 'PROCESSING'
}
